 <template>
  <div class="Weave"> 
    <div v-if="status == 'show'"> 
      <WeaveButton v-if="this.$route.params.section == 'weave'" />
      <CenterButton v-if="this.$route.params.section == 'recenter'" />
      <PlaceTheLoom v-if="this.$route.params.section == undefined "/>
    </div>
  </div> 
</template>

<script>

import gsap from "gsap"
import PlaceTheLoom from "./assets/PlaceTheLoom.vue"
import WeaveButton from "./assets/WeaveButton.vue"
import CenterButton from "./assets/CenterButton.vue"

export default {

  name: 'Weave',
  components: { PlaceTheLoom, WeaveButton, CenterButton },
  data: ()=>({
    tw: null,
    status: 'none'
  }),
  computed: {
    weave_button() { return this.$store.getters['app/weave_button'] },
  },
  watch: {
    weave_button(nw, od) {
      this.status = nw
    },
    '$route': {
      immediate: true,
      handler() {

        this.$store.commit('app/SYNC_AUDIO', 'none')
        this.$nextTick(()=>{ 
          this.status = 'show' 
        })
        if(this.$route.params.section == undefined
        && this.$root.route.from.params.section != 'finish')
          this.$store.commit('app/UPDATE_STATUS', 'init')
        else if(this.$route.params.section == 'weave') {
          if(this.tw)
            this.tw.kill()

          this.tw = gsap.delayedCall(2.5, ()=> {
            // console.log('delayedCall !!!');

            this.$store.commit('app/SYNC_AUDIO', 'option')

          })

        }
      }
    }
  },

  beforeDestroy() {
    this.$store.commit('app/SYNC_AUDIO', 'none')
  },

  mounted() {
    this.$nextTick(()=>{ this.status = 'show' })
  },

}

</script>

<style lang="stylus">
@import '~@/config/Settings'

.Weave
  top 0
  left 0
  width 100%

</style>


